import React from "react";
import { Link, useParams } from "react-router-dom";
import Language from "./Language";
import { FlexEnd } from "../../components/Flex/";
import WhiteButton from "../../components/WhiteButton";
import { fontSmall } from "../../constants";
import { SupportIcon } from "./SupportIcon";
import { LogOutIcon } from "./LogOutIcon";
import { useKeycloakContext } from "../../contexts/AuthContext";

export const UpperMenu = (props) => {
  const { ...keycloak } = useKeycloakContext();
  const { lang } = useParams();
  const handleLogout = () => {
    keycloak.logout();
  };

  return (
    <FlexEnd
      style={{ textAlign: "right", height: "42px", alignItems: "center" }}
    >
      <Language />
      <Link
        to={`/${lang}/help`}
        style={{
          marginRight: "8px",
          // marginRight: '24px',
          textDecoration: "none",
        }}
      >
        <WhiteButton
          style={{
            fontSize: fontSmall,
            textDecoration: "none",
          }}
          leftIcon={<SupportIcon />}
          textKeys="Help"
        />
      </Link>
      {
        <WhiteButton
          style={{
            fontSize: fontSmall,
            textDecoration: "none",
          }}
          leftIcon={<LogOutIcon />}
          textKeys="Logout"
          onClick={handleLogout}
        />
      }
    </FlexEnd>
  );
};
